import React from "react";
import {KButton, KBUTTON_SIZE, KBUTTON_VARIANT, KNavbar, KNavBrandFixed, KNavDropdown, KNavDropdownItem, KNavLangSelector, noop} from "@kopjra/uikit";
import {translations} from "../locale";
import {Translate} from "react-redux-i18n";
import {useAuth0} from "@auth0/auth0-react";

export interface StateProps {
    locale: string;
    isAllowed: boolean;
}

export interface DispatchProps {
    onChangeLocale: (locale: string) => void;
    onGoAccount: () => void;
    onGoToHtmlInteractions: () => void;
    onGoToDataInteractions: () => void;
    onGoToPdfInteractions: () => void;
    onGoToAesInteractions: () => void;
    onGoToPdfSimpleInteractions: () => void;
    onGoToTimestamps: () => void;
    onGoToApiKeys: () => void;
    onGoToDocs: () => void;
    onGoToValidator: () => void;
    onGoToStore: () => void;
    onGoArchCall: () => void;
}

export interface InnerProps {
}

export type Props = StateProps & DispatchProps & InnerProps;

export const Toolbar: React.FC<Props> = ({onGoToAesInteractions, onGoToPdfSimpleInteractions, onGoArchCall, onGoToStore, isAllowed, onGoToTimestamps, onGoToValidator, onGoToDocs, onGoToApiKeys, onGoToDataInteractions, onGoToHtmlInteractions, onGoToPdfInteractions, locale, onChangeLocale, onGoAccount}) => {
    const {isAuthenticated, loginWithRedirect, logout, user} = useAuth0();
    const userOK = isAuthenticated && !!user?.email_verified;
    // const {location} = useRouter();
    return (
        <KNavbar
            brand={<KNavBrandFixed iconPartial={"web-trust"} appName="Web Trust"/>}
            rightMost={
                <>
                    <KNavLangSelector  onChangeLocale={(loc) => onChangeLocale(loc)} locale={locale} translations={translations} alignRight={true}/>
                    <KButton
                        text={isAllowed ? <Translate value={"user.intDoc"}/> : <Translate value={"user.buy"}/>}
                        variant={KBUTTON_VARIANT.primary}
                        onClick={() => isAllowed ? onGoToDocs() : onGoToStore()}
                        size={KBUTTON_SIZE.xs}
                    />
                </>
            }
            statusPageComponentIds={["z9vwjgg61xyr"]}
        >
            {userOK ? (
                <>
                    <KNavDropdown id={"dash.endpoints"} title={<Translate value={"menu.endpoints.title"}/>}>
                        <KNavDropdownItem onClick={() => onGoToAesInteractions()}><Translate value={"menu.endpoints.aes"}/></KNavDropdownItem>
                        <KNavDropdownItem onClick={() => onGoToPdfInteractions()}><Translate value={"menu.endpoints.pdf"}/></KNavDropdownItem>
                        <KNavDropdownItem onClick={() => onGoToPdfSimpleInteractions()}><Translate value={"menu.endpoints.pdfsimple"}/></KNavDropdownItem>
                        <KNavDropdownItem onClick={() => onGoToHtmlInteractions()}><Translate value={"menu.endpoints.html"}/></KNavDropdownItem>
                        <KNavDropdownItem onClick={() => onGoToDataInteractions()}><Translate value={"menu.endpoints.data"}/></KNavDropdownItem>
                        <KNavDropdownItem onClick={() => onGoToTimestamps()}><Translate value={"menu.endpoints.timestamp"}/></KNavDropdownItem>
                    </KNavDropdown>
                    <KNavDropdown id={"dash.administration"} title={<Translate value={"menu.admin.title"}/>}>
                        <KNavDropdownItem onClick={() => onGoToApiKeys()}><Translate value={"menu.admin.apiKeys"}/></KNavDropdownItem>
                        {/*TODO: create Archetypes and Callbacks admin page*/}
                        <KNavDropdownItem onClick={() => onGoArchCall()}><Translate value={"menu.admin.archCall"}/></KNavDropdownItem>
                        <KNavDropdownItem onClick={() => onGoToDocs()}><Translate value={"menu.admin.docs"}/></KNavDropdownItem>
                        <KNavDropdownItem onClick={() => onGoToValidator()}><Translate value={"menu.admin.validator"}/></KNavDropdownItem>
                    </KNavDropdown>
                </>
            ) : null}
            <KNavDropdown id={"user.profile-dropdown"} title={<Translate value="user.account"/>} versionVerifier={true}>
                {!isAuthenticated ? (
                    <>
                        <div style={{padding: 20, width: "100%"}}>
                            <KButton text={<span><i className="fal fag fa-sign-in"/> <Translate value="user.login"/></span>} variant={KBUTTON_VARIANT.success} size={KBUTTON_SIZE.sm}
                                     onClick={() => loginWithRedirect({ui_locales: locale})} fill={true}/>
                        </div>
                        <KNavDropdownItem onClick={() => noop()}>
                            <Translate value="user.support"/>
                        </KNavDropdownItem>
                     </>
                ) : (
                    <>
                        <KNavDropdownItem onClick={() => onGoAccount()}>
                            <Translate value="user.profile"/>
                        </KNavDropdownItem>
                        <KNavDropdownItem onClick={() => {window.open("mailto:support@kopjra.com", "_blank")}}>
                            <Translate value="user.support"/>
                        </KNavDropdownItem>
                        <KNavDropdownItem onClick={() => logout({returnTo: "https://webtrust.kopjra.com"})}>
                            <Translate value="user.logout"/>
                        </KNavDropdownItem>
                    </>
                )}
            </KNavDropdown>
        </KNavbar>
    );
}
